import { HotelRoomingListGuestAdapter } from '../adapters/booking-api-client/hotel-rooming-list-guest.ts'
import { HotelRoomingListAdapter } from '../adapters/booking-api-client/hotel-rooming-list.ts'

import { defineBackendStore } from './backend-store.ts'

import type { HotelRoomingListAdapterProps } from '../adapters/booking-api-client/hotel-rooming-list.ts'
import type {
  HotelRoomingListApi,
  HotelRoomingListGuestsCreatePayload,
  HotelRoomingListGuestsDeletePayload,
  HotelRoomingListGuestsUpdatePayload,
} from '@revolugo/booking-api-client'
import type { HotelRoomingListGuestResponseDto } from '@revolugo/graphql/private'

export interface HotelRoomingListModule {
  list: (token: string) => Promise<HotelRoomingListAdapterProps[]>
}

export interface HotelRoomingListGuestsModule {
  create: (
    options: HotelRoomingListGuestsCreatePayload,
  ) => Promise<
    Omit<HotelRoomingListGuestResponseDto, 'createdAt' | 'updatedAt'>
  >
  delete: (options: HotelRoomingListGuestsDeletePayload) => Promise<string>
  update: (
    options: HotelRoomingListGuestsUpdatePayload,
  ) => Promise<
    Omit<HotelRoomingListGuestResponseDto, 'createdAt' | 'updatedAt'>
  >
}

export const useHotelRoomingListServiceStore =
  defineBackendStore<HotelRoomingListModule>('hotel-rooming-list', {
    actions: {
      async list(token: string): Promise<HotelRoomingListAdapterProps[]> {
        const hotelRoomingLists =
          await this.apiClient.hotelRoomingListsService.list({ token })

        const hotelRoomingListAdapters = hotelRoomingLists.map(
          (hotelRoomingList: HotelRoomingListApi) => {
            const hotelRoomingListAdapter = new HotelRoomingListAdapter(
              hotelRoomingList,
            )
            return hotelRoomingListAdapter.toHotelRoomingList()
          },
        )

        return hotelRoomingListAdapters
      },
    },
  })

export const useHotelRoomingListGuestsServiceStore =
  defineBackendStore<HotelRoomingListGuestsModule>(
    'hotel-rooming-list-guests',
    {
      actions: {
        async create(
          options: HotelRoomingListGuestsCreatePayload,
        ): Promise<
          Omit<HotelRoomingListGuestResponseDto, 'createdAt' | 'updatedAt'>
        > {
          const hotelRoomingListGuest =
            await this.apiClient.hotelRoomingListGuestsService.create(options)

          const hotelRoomingListGuestAdapter = new HotelRoomingListGuestAdapter(
            hotelRoomingListGuest,
            // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
            options.hotelRoomingListGuestsCreateApi?.hotelRoomingListId!,
          )
          return hotelRoomingListGuestAdapter.toHotelRoomingListGuest()
        },
        delete(options: HotelRoomingListGuestsDeletePayload) {
          return this.apiClient.hotelRoomingListGuestsService.delete(options)
        },
        async update(
          options: HotelRoomingListGuestsUpdatePayload,
        ): Promise<
          Omit<HotelRoomingListGuestResponseDto, 'createdAt' | 'updatedAt'>
        > {
          const hotelRoomingListGuest =
            await this.apiClient.hotelRoomingListGuestsService.update(options)

          const hotelRoomingListGuestAdapter = new HotelRoomingListGuestAdapter(
            hotelRoomingListGuest,
            '',
          )
          return hotelRoomingListGuestAdapter.toHotelRoomingListGuest()
        },
      },
    },
  )
